import Vue from "vue";

import { DsnRepresentation } from "@/lib/apis/replicable/models";
import i18n from "@/lib/i18n";

function filter(dsn: DsnRepresentation): string {
	if (dsn.fileName) {
		const tooltipLines = [dsn.fileName];

		if (dsn.fraction) {
			tooltipLines.push(`Fraction : ${dsn.fraction.number}/${dsn.fraction.count}`);
		}

		return tooltipLines.join("\n");
	}

	i18n.mergeLocaleMessage("fr", {
		noName: "DSN sans nom (#{id})"
	});

	return i18n.t("noName", dsn) as string;
}

export default {
	install() {
		Vue.filter("dsn", filter);
	}
};

export { filter };
